import React from "react";
import Heading from "@/components/atoms/Heading";
import { useTranslation } from "react-i18next";
import { SettingsFormContent, SettingsHeader } from "@/components/pages/Settings/index";
import Text from "@/components/atoms/Text";
import ArchivedContractsTable from "@/components/organisms/ArchivedContractsTable";
import { DEFAULT_ARCHIVED_CONTRACT_COLUMN } from "@/components/organisms/ArchivedContractsTable/const/default";
import { Grid, Stack } from "@mantine/core";

export const ContractArchive: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack data-testid="contract-archive-settings">
      <Heading order={2} styleOrder={4} tt="uppercase">
        {t("settings:navigation.contractArchive")}
      </Heading>
      <SettingsFormContent>
        <Grid>
          <SettingsHeader showDivider={false}>
            <Text size="md" strong={true} display="technical" tt="uppercase">
              {t("settings:contractArchive.contractArchiveList")}
            </Text>
          </SettingsHeader>
          <Grid.Col span={12}>
            <ArchivedContractsTable visibleColumns={DEFAULT_ARCHIVED_CONTRACT_COLUMN} />
          </Grid.Col>
        </Grid>
      </SettingsFormContent>
    </Stack>
  );
};

export default ContractArchive;
